export const ANALYTICS_CONTRACTOR = 'ANALYTICS_CONTRACTOR';
export const ANALYTICS_APARTMENT_STATUS = 'ANALYTICS_APARTMENT_STATUS';
export const ANALYTICS_RATING = 'ANALYTICS_RATING';
export const ANALYTICS_REPORTING_OVP = 'ANALYTICS_REPORTING_OVP';
export const ANALYTICS_TRANSFER_TO_SETTLEMENT = 'ANALYTICS_TRANSFER_TO_SETTLEMENT';
export const APARTMENT_LIST_PAGE = 'APARTMENT_LIST_PAGE';
export const APARTMENT_STATUS_PAGE = 'APARTMENT_STATUS_PAGE';
export const CALLS_APARTMENTS_ALLOCATED_PAGE = 'CALLS_APARTMENTS_ALLOCATED_PAGE';
export const CALLS_APARTMENTS_UNALLOCATED_PAGE = 'CALLS_APARTMENTS_UNALLOCATED_PAGE';
export const CALLS_COMMERCIAL_APARTMENT = 'CALLS_COMMERCIAL_APARTMENT';
export const CALLS_COMMERCIAL_REPORTING = 'CALLS_COMMERCIAL_REPORTING';
export const CALLS_ENGINEERING_ACCEPTED_PAGE = 'CALLS_ENGINEERING_ACCEPTED_PAGE';
export const CALLS_ENGINEERING_ALLOCATED_PAGE = 'CALLS_ENGINEERING_ALLOCATED_PAGE';
export const CALLS_ENGINEERING_UNALLOCATED_PAGE = 'CALLS_ENGINEERING_UNALLOCATED_PAGE';
export const CALLS_MY_CALLS = 'CALLS_MY_CALLS';
export const CALLS_PAGE = 'CALLS_PAGE';
export const CALLS_PRIME_CONTRACTOR_APARTMENT = 'CALLS_PRIME_CONTRACTOR_APARTMENT';
export const DEFECTS_ENGINEERING_PAGE = 'DEFECTS_ENGINEERING_PAGE';
export const DEFECTS_PAGE = 'DEFECTS_PAGE';
export const DOCUMENTS_PAGE = 'DOCUMENTS_PAGE';
export const EN_NETWORKS_STATUS_PAGE = 'EN_NETWORKS_STATUS_PAGE';
export const ENGINEERING_PAGE = 'ENGINEERING_PAGE';
export const ENGINEERING_SETTING_PAGE = 'ENGINEERING_SETTING_PAGE';
export const ENGINEERING_SETTING_PAGE_OBJECTS = 'ENGINEERING_SETTING_PAGE_BY_OBJECTS';
export const ENGINEERING_SETTING_PAGE_PROJECTS = 'ENGINEERING_SETTING_PAGE_BY_PROJECTS';
export const PLACEMENTS_STATUS_PAGE = 'PLACEMENTS_STATUS_PAGE';
export const PLAN_ALL_VERSIONS_PAGE = 'PLAN_ALL_VERSIONS_PAGE';
export const PLAN_ENGINEERING_PAGE = 'PLAN_ENGINEERING_PAGE';
export const PLAN_OVP = 'PLAN_OVP';
export const PLAN_PAGE = 'PLAN_PAGE';
export const PLAN_TRANSFER_OVP = 'PLAN_TRANSFER_OVP';
export const PLAN_TRANSFER_DETAILS = 'PPLAN_TRANSFER_DETAILS';
export const START_SETTLEMENT_PAGE = 'START_SETTLEMENT_PAGE';
export const STATUS_PAGE = 'STATUS_PAGE';
export const TIMESHEET_APARTMENTS_PAGE = 'TIMESHEET_APARTMENTS_PAGE';
export const TIMESHEET_ENG_NETWORKS_PAGE = 'TIMESHEET_ENG_NETWORKS_PAGE';
export const TIMETABLE_PAGE = 'TIMETABLE_PAGE';
